/**
 * Payment-related models
 */

/**
 * Payment DTO (Response)
 */
export interface PaymentDto {
  id: string;
  leaseId: string;
  amount: number;
  type?: string | null;
  method?: string | null;
  transactionDate: string;
  status?: string | null;
  referenceNo?: string | null;
  receiptUrl?: string | null;
  createdAt: string;
  updatedAt: string;
}

/**
 * Create payment request
 */
export interface CreatePaymentRequest {
  leaseId: string;
  amount: number;
  type?: string | null;
  method?: string | null;
  transactionDate: string;
  referenceNo?: string | null;
}

/**
 * Process payment request (for payment gateway integration)
 */
export interface ProcessPaymentRequest {
  leaseId: string;
  amount: number;
  type?: string | null;
  method?: string | null;
  transactionDate: string;
  referenceNo?: string | null;
  paymentToken?: string | null; // For payment gateway integration
  cardLastFour?: string | null; // For card payments
}

